/**
 * VirtualList DOM 接线中可独立单测的纯逻辑（组件本体 VirtualList.tsx 只做接线，
 * 行为验证归 7c 的 10k demo 路由 e2e）。
 */

/**
 * ResizeObserverEntry 的结构子集：真实 entry 直接满足；测试用普通对象构造。
 * borderBoxSize 在旧 Safari（iOS < 15.4）运行时缺失，故标记可选。
 */
export interface MeasurableEntry {
  readonly borderBoxSize?: ReadonlyArray<{ readonly blockSize: number }>;
  readonly contentRect: { readonly height: number };
}

/**
 * RO 条目 → 行高。borderBoxSize 优先（分数像素精度）；旧 Safari 回退
 * contentRect——行包装元素无 border/padding，两者数值等价。
 */
export function entryHeight(entry: MeasurableEntry): number {
  const box = entry.borderBoxSize?.[0];
  return box !== undefined ? box.blockSize : entry.contentRect.height;
}

/**
 * 触顶加载门控：items 每变化一次（首 key 或数量变了）重新上膛，距顶 ≤ thresholdPx
 * 时触发一次后熄火——prepend 不动滚动位置也能续加载（短历史填不满屏），又不会在
 * 「没有更多历史」时连环触发（调用方不再变更 items 即保持熄火）。
 */
export interface ReachTopGate {
  /** items 提交后调用。首 key 或数量变化 → 重新上膛（空列表不上膛）。 */
  onItems(firstKey: string | undefined, count: number): void;
  /** 每次 commit 后调用。true = 应触发 onReachTop（随即熄火）。 */
  check(scrollTop: number, viewportPx: number): boolean;
}

export function createReachTopGate(thresholdPx: number): ReachTopGate {
  let armed = false;
  let lastFirst: string | undefined;
  let lastCount = -1;
  return {
    onItems(firstKey, count) {
      if (firstKey === lastFirst && count === lastCount) return;
      lastFirst = firstKey;
      lastCount = count;
      armed = count > 0;
    },
    check(scrollTop, viewportPx) {
      if (!armed || viewportPx <= 0 || scrollTop > thresholdPx) return false;
      armed = false;
      return true;
    },
  };
}
